import React from "react";
import { Typography, Box } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const Footer_Internal: React.FC = () => {

  const theme = useTheme();


  return (
    <Box
      component="footer"
      sx={{
        bgcolor: theme.custom.ui.footer.main.dark,
        color: theme.custom.base.text.primary.dark,      // soft white text
        py: 1,
        textAlign: "right",
        mt: "auto", // Pushes footer to the bottom
      }}
    >
      <Typography variant="body2" color={theme.custom.base.text.primary.dark} mr={10}>
        © {new Date().getFullYear()} Pathway Technologies · All rights reserved
      </Typography>
    </Box>
  );
};

export default Footer_Internal;
